import { createFileRoute } from '@tanstack/react-router'

import { NeonSettingsPage } from '#features/integrations/neon/neon-settings-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/neon',
)({
  head: () => ({
    meta: [
      {
        title: 'Neon integration',
      },
    ],
  }),
  component: () => <NeonSettingsPage />,
})
